import { UserIdCardItem } from "../userIdCard/userIdCardItem";
import { getApiCall } from "./tokenService";

export const getUserIdCardItem = (): Promise<UserIdCardItem> => {
    return getApiCall("api/recorduser/idcard", UserIdCardItem);
};
